import type { TFunction } from 'i18next';
import type { RefinementCtx } from 'zod';
import type { ContentTypeDefinition } from '../../../lib/flotiq-client/types/api-response';

import { z } from 'zod';

const checkListItems = (
  value: ContentTypeDefinition['metaDefinition']['propertiesConfig'],
  context: RefinementCtx,
  t: TFunction,
  propSubName?: string,
) => {
  Object.keys(value).forEach((propName) => {
    const property = value[propName];
    if (property?.inputType === 'object' && property?.items) {
      if (
        !property.items.propertiesConfig ||
        Object.keys(property.items.propertiesConfig).length === 0
      ) {
        context.issues.push({
          code: 'custom',
          path: propSubName
            ? [propName, propSubName, 'items', 'propertiesConfig']
            : [propName, 'items'],
          message: t('ContentTypeForm.Errors.OneProperty'),
          input: property,
        });
      } else {
        checkListItems(property.items.propertiesConfig, context, t, propName);
      }
    }
  });
};

export const generateZodSchema = (t: TFunction) =>
  z.object({
    label: z
      .string()
      .min(1, t('Form.FormErrorNotBlank'))
      .refine(
        (value) => !value?.startsWith('/'),
        t('Form.FormErrorNotStartWithSlash'),
      )
      .refine(
        (value) => (value?.match(/\//g) || []).length <= 1,
        t('Form.FormErrorNoMoreThanOneSlash'),
      ),
    name: z.string(),
    draftPublic: z.boolean(),
    autoSave: z.boolean(),
    metaDefinition: z.object({
      order: z.array(z.string()),
      propertiesConfig: z
        .record(z.string(), z.any())
        .superRefine((value, ctx) => {
          checkListItems(value, ctx, t);
        }),
    }),
    schemaDefinition: z.object({
      type: z.literal('object'),
      required: z.array(z.string()),
      additionalProperties: z.literal(false),
      allOf: z.tuple([
        z.object({
          $ref: z.string(),
        }),
        z.object({
          type: z.literal('object'),
          properties: z.record(z.string(), z.any()),
        }),
      ]),
    }),
    featuredImage: z
      .object({
        dataUrl: z.string(),
        type: z.string(),
      })
      .array()
      .optional(),
    slugs: z.array(
      z.object({
        source: z
          .string()
          .min(1, t('ContentTypeForm.SlugsSettingsModal.Errors.MinLength')),
        target: z
          .string()
          .min(1, t('ContentTypeForm.SlugsSettingsModal.Errors.MinLength')),
        active: z.boolean(),
      }),
    ),
  });
